import React from 'react'
import { connect } from 'react-redux'
import {
  Button,
  FormGroup
} from 'reactstrap'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import AlertMessage from '../../components/AlertMessage'
import DeviseLayout from '../DeviseLayout'
import history from '../../helpers/History'
import PageLoader from '../../components/PageLoader'
import PasswordField from '../../components/PasswordField'
import invitationActions from './actions'

class DeviseInvitationAccept extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      invitationToken: null,
      password: '',
      passwordConfirmation: ''
    }
  }

  componentDidMount() {
    const { location: { search } } = this.props

    const urlParams = new URLSearchParams(search)
    const invitationToken = urlParams.get('invitation_token')

    this.setState({
      invitationToken
    })
  }

  componentDidUpdate(prevProps) {
    const { acceptingStatus: prevAcceptingStatus } = prevProps
    const { acceptingStatus } = this.props

    if (prevAcceptingStatus === 'accepting') {
      if (acceptingStatus === 'failed') {
        this.showFormErrors()
      } else {
        history.push('/users/sign_in')
      }
    }
  }

  handleSubmit(event) {
    const { dispatch } = this.props
    const { password, passwordConfirmation, invitationToken } = this.state

    event.preventDefault()

    if (password === '') {
      this.passwordField.showAsInvalid()
    }

    if (passwordConfirmation === '') {
      this.passwordConfirmationField.showAsInvalid()
    }

    if (password && passwordConfirmation) {
      dispatch(invitationActions.accept({
        invitationToken,
        password,
        passwordConfirmation
      }))
    }
  }

  handlePasswordChange({ target: { name, value } }) {
    this.setState({
      [name]: value
    })
  }

  showFormErrors() {
    const {
      acceptingError: {
        password,
        password_confirmation: passwordConfirmation
      }
    } = this.props

    if (password) {
      this.passwordField.showAsInvalid(password)
    }

    if (passwordConfirmation) {
      this.passwordConfirmationField.showAsInvalid(passwordConfirmation)
    }
  }

  render() {
    const {
      acceptingStatus,
      t
    } = this.props
    const {
      invitationToken
    } = this.state

    const { password, passwordConfirmation } = this.state

    return (
      <DeviseLayout
        id="edit-user"
        onSubmit={(event) => this.handleSubmit(event)}
        title={t('DeviseInvitationAccept.title', { ns: 'devise' })}
      >
        <PasswordField
          inputId="user-password"
          inputName="password"
          onChange={(event) => this.handlePasswordChange(event)}
          ref={(component) => { this.passwordField = component }}
          value={password}
        />
        <PasswordField
          inputId="user-password-confirmation"
          inputName="passwordConfirmation"
          labelText={t('fields.passwordConfirmation', { ns: 'devise' })}
          onChange={(event) => this.handlePasswordChange(event)}
          ref={(component) => { this.passwordConfirmationField = component }}
          value={passwordConfirmation}
        />
        {!invitationToken && (
          <AlertMessage color="warning">
            {t('DeviseInvitationAccept.noToken', { ns: 'devise' })}
          </AlertMessage>
        )}
        <FormGroup>
          <div className="d-flex flex-column">
            {acceptingStatus === 'accepting' && (
              <PageLoader
                message={t('DeviseInvitationAccept.accepting', { ns: 'devise' })}
              />
            )}

            <Button
              className="mb-5"
              color="primary"
              disabled={acceptingStatus === 'accepting'}
              name="commit"
            >
              {t('DeviseInvitationAccept.setMyPassword', { ns: 'devise' })}
            </Button>
            <Link
              className="mb-3 btn btn-secondary"
              disabled={acceptingStatus === 'accepting'}
              to="/users/sign_in"
            >
              {t('buttons.login', { ns: 'commons' })}
            </Link>
          </div>
        </FormGroup>
      </DeviseLayout>
    )
  }
}

DeviseInvitationAccept.propTypes = {
  acceptingError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  acceptingStatus: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired,
  t: PropTypes.func.isRequired
}

DeviseInvitationAccept.defaultProps = {
  acceptingError: null,
  acceptingStatus: 'idle'
}

const mapStateToProps = ({
  invitations: {
    acceptingError,
    acceptingStatus
  }
}) => ({
  acceptingError,
  acceptingStatus
})

export default withTranslation(['devise', 'commons'])(
  connect(mapStateToProps)(DeviseInvitationAccept)
)
